<template>
  <div class="login-wrapper">
    <div class="login-form-wrapper">
      <div class="administration-logo">
        <img src="../../assets/img/logo.svg" alt="KCM">
        <span>АДМИНИСТРАЦИЯ</span>
      </div>
      <form @submit.prevent="login()" v-if="validated">
        <p class="error-message" v-if="errorMessage">{{ errorMessage }}</p>
        <div class="input">
          <label for>{{$t('username')}}</label>
          <input type="text" :placeholder="$t('username')" v-model="user.username">
        </div>
        <div class="input">
          <label for>{{$t('password')}}</label>
          <input type="password" :placeholder="$t('password')" v-model="user.password">
        </div>
        <button type="submit">{{ $t('login') }}</button>
        <p class="text-light cdots">&copy; Решението е разработено от cDots Corporation, 2019</p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      validated: false,
      user: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    isValid() {
      if (!this.user.username) {
        this.errorMessage = this.$t("no-username");
        return false;
      }
      if (!this.user.password) {
        this.errorMessage = this.$t("no-password");
        return false;
      }
      return true;
    },
    login() {
      if (this.isValid()) {
        this.$store
          .dispatch("login", this.user)
          .then(() => this.$router.push("/administration"))
          .catch(err => {
            // eslint-disable-next-line
            console.log(err);
            this.errorMessage = err.response.data.message;
          });
      }
    }
  },
  mounted() {
    const token = localStorage.getItem("token");
    this.$http
      .post(`${process.env.VUE_APP_BASE_URI}/auth/validate`, { token: token })
      .then(res => {
        if (res.data.user) {
          this.$router.push("/administration");
        }
      })
      .catch(err => {
        // eslint-disable-next-line
        console.log(err);
      })
      .then(() => {
        this.validated = true;
      });
  }
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  align-items: center;
  background-image: url("../../assets/img/administration/bg.jpg");
  background-position: 50% 0;
  background-size: cover;
  display: flex;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 10px;
  position: relative;
  width: 100%;
}
.login-wrapper::before {
  background-color: $mainColor;
  bottom: 0;
  content: "";
  height: 20vh;
  left: 0;
  position: absolute;
  width: 100%;
}
.login-form-wrapper {
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  height: calc(100vh - 20px);
  justify-content: space-between;
  left: 10px;
  position: fixed;
  top: 10px;
  text-transform: uppercase;
  width: 250px;
}
.administration-logo {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 15px 30px;
  width: 100%;
  img {
    display: block;
    height: auto;
    width: 100%;
  }
  span {
    color: #004785;
    font-size: 9px;
    font-weight: 500;
    letter-spacing: 3px;
    margin-top: 10px;
  }
}
form {
  display: flex;
  flex-direction: column;
  width: 100%;
  .input {
    margin: 0;
    padding: 0 25px 30px;
    label {
      color: $mainColor3;
      font-weight: 400;
    }
    input {
      background-color: transparent;
      border-left: none;
      border-right: none;
      border-top: none;
      outline: none;
      padding: 0;
    }
    input:focus {
      border-left: none;
      border-right: none;
      border-top: none;
    }
  }
  button {
    height: 58px;
  }
  .cdots {
    background-color: $mainColor;
    font-size: 9px;
    font-weight: 400;
    line-height: 12px;
    padding-top: 25px;
    text-align: center;
    text-transform: initial;
  }
}
.error-message {
  color: #ca340f;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  padding: 0 25px 30px;
  text-align: center;
  text-transform: initial;
}
</style>
